import { type AdminUserSummary } from "../../services/UserService";

export type UserPlanFilter =
  | "active"
  | "basic" | "plus" | "pro"
  | "target" | "dollar_general" | "bestbuy";

export const USER_PLAN_FILTER_LABELS: Record<UserPlanFilter, string> = {
  active: "Active users",
  basic: "Basic",
  plus: "Plus",
  pro: "Pro",
  target: "Target",
  dollar_general: "Dollar General",
  bestbuy: "Best Buy",
};

export type PlanTier = "basic" | "plus" | "pro";

/** walmart_starter is legacy naming for Walmart Pro. */
export function planTierOf(retailer: string): PlanTier | null {
  if (retailer.includes("_plus")) return "plus";
  if (retailer.includes("_pro") || retailer.includes("_starter") || retailer.includes("_enterprise")) return "pro";
  if (retailer.includes("_basic")) return "basic";
  return null;
}

export const userHasTier = (user: AdminUserSummary, tier: PlanTier) =>
  user.retailers?.some((r) => planTierOf(r) === tier) ?? false;

/** Premium retailers (Target/DG/BB) only count when the user is on a Plus-or-higher plan. */
export const userHasPlusOrHigher = (user: AdminUserSummary) =>
  user.retailers?.some((r) => {
    const tier = planTierOf(r);
    return tier === "plus" || tier === "pro";
  }) ?? false;

export function userMatchesPlanFilter(user: AdminUserSummary, filter: UserPlanFilter): boolean {
  switch (filter) {
    case "active":
      return (user.retailers?.length ?? 0) > 0;
    case "basic":
    case "plus":
    case "pro":
      return userHasTier(user, filter);
    case "target":
      return (user.targetStoreIds?.length ?? 0) > 0 && userHasPlusOrHigher(user);
    case "dollar_general":
      return (user.dollarGeneralStoreIds?.length ?? 0) > 0 && userHasPlusOrHigher(user);
    case "bestbuy":
      return (user.bestbuyStoreIds?.length ?? 0) > 0 && userHasPlusOrHigher(user);
  }
}
